import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const isDev = window.location.hostname === "localhost";

  if (!token && !isDev) {
    console.warn("⛔ אין טוקן (בפרודקשן) - מפנה להתחברות");
    return <Navigate to="/moralandamirlo" />;
  }

  return children;
};

export default ProtectedRoute;
